// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-A1":"A1_outdoor-recreation-A1__hcbCP"};